// extracted by mini-css-extract-plugin
export var tabContainer = "creativeStudioSlideshow-module--tabContainer--Bl1NH";
export var active = "creativeStudioSlideshow-module--active--mkWRN";
export var slide = "creativeStudioSlideshow-module--slide--pjhMr";
export var fadeIn = "creativeStudioSlideshow-module--fadeIn--dtti-";
export var slideshowCont = "creativeStudioSlideshow-module--slideshowCont--9BMa3";
export var prevBtn = "creativeStudioSlideshow-module--prevBtn--kmV-X";
export var nextBtn = "creativeStudioSlideshow-module--nextBtn--yCF5Z";
export var slideIn = "creativeStudioSlideshow-module--slideIn--r3srD";